<template>
    <div class="site-main-container">

        <div v-if="this.impersonated && this.impersonatedUrl" class="impersonating-banner">
            <app-icon :name="'user'" width="22" height="22" class="mb-1 mr-1" /> {{ $t("impersonating_as_employee") }} {{ this.impersonated.name }} {{ this.impersonated.surname }}
        </div>

        <div class="checklist-container border-0">

            <div class="site-logo">
                <img :src="this.settings.company_logo">
            </div>
            <div v-if="isDateInFuture(this.impersonated.event_date) && this.user.addressing_by_name" class="d-flex">
                <div>
                    <h2>
                        {{ this.settings.company_greeting ? this.settings.company_greeting : 'Ahoj' }}  {{ this.impersonated.addressing_by_name ? this.impersonated.addressing_by_name : this.user.addressing_by_name }},<br>
                        těšíme se na {{ this.settings.company_addressing ? this.settings.company_addressing : 'tebe' }}!
                    </h2>
                </div>
                <div>
                    <video class="ml-4 mt-2 animated-emoji" width="56" height="56" autoplay muted loop>
                        <source src="/images/icons/emoji_animated_sunglasses.mp4" type="video/mp4">
                    </video>
                </div>
            </div>
            <div v-else-if="this.user.addressing_by_name" class="d-flex">
                <div>
                    <h2>
                        {{ this.settings.company_greeting ? this.settings.company_greeting : 'Ahoj' }}  {{ this.impersonated.addressing_by_name ? this.impersonated.addressing_by_name : this.user.addressing_by_name }},<br>
                        jsme rádi, že {{ this.settings.company_addressing == "tebe" ? 'tě' : 'Vás' }} máme!
                    </h2>
                </div>
                <div>
                    <video class="ml-4 mt-2 animated-emoji" width="56" height="56" autoplay muted loop>
                        <source src="/images/icons/emoji_animated_sunglasses.mp4" type="video/mp4">
                    </video>
                </div>
            </div>
            <div v-if="isDateInFuture(this.impersonated.event_date)" class="calendar-container">
                <div class="calendar-square">
                    <span>{{ formatMonthDate(this.impersonated.event_date) }}</span>
                    {{ formatShortDate(this.impersonated.event_date) }}
                </div>
                <div class="calendar-text">
                    Už <strong>{{ formatDate(this.impersonated.event_date) }}</strong> v {{ formatTime(this.impersonated.event_date) }} <br>
                    na viděnou!
                </div>
            </div>
            
            <div v-if="this.checklistsLoaded && this.impersonated">

                <app-checklist-form v-if="this.impersonated.timeline_state >= 7" id="timeline_employee_7" :candidate-id='this.impersonateAs.toString()' :timeline-state-id="7" :timeline-state-name="timelineStates[0]" :type-id="2" :event-date="this.impersonated.event_date" :current-timeline-state-id="this.impersonated.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter( t => t.timeline_state == 7) : ''" :only-view="true"></app-checklist-form>

                <app-checklist-form v-if="this.impersonated.timeline_state >= 8" id="timeline_employee_8" :candidate-id='this.impersonateAs.toString()' :timeline-state-id="8" :timeline-state-name="timelineStates[1]" :type-id="2" :event-date="this.impersonated.event_date" :current-timeline-state-id="this.impersonated.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter( t => t.timeline_state == 8) : ''" :only-view="true"></app-checklist-form>

                <app-checklist-form v-if="this.impersonated.timeline_state >= 9" id="timeline_employee_9" :candidate-id='this.impersonateAs.toString()' :timeline-state-id="9" :timeline-state-name="timelineStates[2]" :type-id="2" :event-date="this.impersonated.event_date" :current-timeline-state-id="this.impersonated.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter( t => t.timeline_state == 9) : ''" :only-view="true"></app-checklist-form>

                <app-checklist-form v-if="this.impersonated.timeline_state >= 10" id="timeline_employee_10" :candidate-id='this.impersonateAs.toString()' :timeline-state-id="10" :timeline-state-name="timelineStates[3]" :type-id="2" :event-date="this.impersonated.event_date" :current-timeline-state-id="this.impersonated.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter( t => t.timeline_state == 10) : ''" :only-view="true"></app-checklist-form>

                <app-checklist-form v-if="this.impersonated.timeline_state >= 11" id="timeline_employee_11" :candidate-id='this.impersonateAs.toString()' :timeline-state-id="11" :timeline-state-name="timelineStates[4]" :type-id="2" :event-date="this.impersonated.event_date" :current-timeline-state-id="this.impersonated.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter( t => t.timeline_state == 11) : ''" :only-view="true"></app-checklist-form>

                <app-checklist-form v-if="this.impersonated.timeline_state >= 12" id="timeline_employee_12" :candidate-id='this.impersonateAs.toString()' :timeline-state-id="12" :timeline-state-name="timelineStates[5]" :type-id="2" :event-date="this.impersonated.event_date" :current-timeline-state-id="this.impersonated.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter( t => t.timeline_state == 12) : ''" :only-view="true"></app-checklist-form>
            </div>
            <div v-else class="text-center mt-5">
                {{ this.$t('nothing_to_show_here_tasks') }}
            </div>

        </div>

        <div id="latest" class="border-0 mb-primary" :class="this.impersonateAs ? 'col-12 col-md-9 p-0 card-left' : 'w-100'">

            <div class="site-bg-image" :style="this.settings.company_banner ? 'background-image: linear-gradient(rgba(255, 255, 255, 0.6) 0px, rgba(255, 255, 255, 1.0) 600px), url('+this.settings.company_banner+')' : ''"></div>
            
            
            <div class="site-menu">
                <a :href="'/employee/dashboard'+this.impersonatedUrl+'#latest'" class="btn btn-light">
                    {{ $t('tasks') }}
                </a>
                <a :href="'/employee/wiki/2'+this.impersonatedUrl" class="btn btn-transparent">
                    {{ $t('employee_wiki') }}
                </a>
            </div>
            <app-overlay-loader v-if="formsPreloader"/>
            <div class="site-content">
                <div v-if="forms">
                    <div v-for="form in forms">
                        <app-form-add-result :form="form" :candidate-id='impersonateAs.toString()' :event-date="impersonated.event_date" :current-timeline-state-id="7" timeline-state-name="'Před nástupem'"/>
                    </div>
                </div>
                <div v-else class="text-center">
                    {{ $t("nothing_to_study") }} <a :href="'/employee/wiki/2'+this.impersonatedUrl">{{ $t("employee_wiki") }}</a>
                </div>
                
                    
                </div>

                <div v-if="courses" class="w-100 p-3">
                    <header class="panel">
                        <h5 class="col-12 pr-0 pt-3"><b>
                            ‍🎓 Aktuálně k prostudování </b>
                        </h5>
                    </header>
                </div>
                <div v-if="courses" v-for="course in courses" class="w-100 p-3">
                    <h3 class="text-center col-12 pr-0 pt-4 pb-3">
                        <b>{{ course.name }}</b>
                    </h3>
                    <iframe v-if="course.attachment" :src="'https://docs.google.com/viewer?url='+course.attachment+'&embedded=true'" style="width:100%;height: 600px;background-color: rgba(125, 125, 125, 0.3)" class="mb-0" frameborder="0"></iframe>
                    <a v-if="course.attachment" :href="course.attachment" class="mb-4" download>Stáhnout soubor</a>
                    <div class="body-container container-md row justify-content-center">
                        <div class="col-sm-12 col-md-8" v-html="course.body"></div>

                    </div>
                </div>

                <div v-if="oldCourses" class="w-100 p-3">
                    <header class="panel">
                        <h5 class="col-12 pr-0 pt-3"><b>
                            Archiv </b>
                        </h5>
                    </header>
                </div>
                <div v-if="oldCourses" v-for="oldCourse in oldCourses" class="w-100 p-3">
                    <h3 class="text-center col-12 pr-0 pt-4 pb-3">
                        <b>{{ oldCourse.name }}</b>
                    </h3>
                    <iframe v-if="oldCourse.attachment" :src="'https://docs.google.com/viewer?url='+oldCourse.attachment+'&embedded=true'" style="width:100%;height: 600px;background-color: rgba(125, 125, 125, 0.3)" class="mb-0" frameborder="0"></iframe>
                    <a v-if="oldCourse.attachment" :href="oldCourse.attachment" class="mb-4" download>Stáhnout soubor</a>
                    <div class="body-container container-md row justify-content-center">
                        <div class="col-sm-12 col-md-8" v-html="oldCourse.body"></div>

                    </div>
                </div>
            </div>



        </div>
        <!-- v-if="this.impersonateAs && this.checklistsLoaded" class="border-0 mb-primary" :class="this.impersonateAs ? 'col-12 col-md-3 p-0' : 'mt-4'" -->
        




    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import GlobalHelperMixin from '../../../../../Mixins/global/GlobalHelperMixin';

    export default {
        name: "Latest",
        mixins: [FormMixin, GlobalHelperMixin],
        props: {
            timelineStates: {
                type: Array,
            },
            user: {
                type: Object,
            }
        },
        watch: {
          user: {
            immediate: true,
            handler (val, oldVal) {
                if(oldVal){
                    if (location.href.indexOf("impersonate=") != -1){
                        // Admin impersonating as an employeee
                        this.ableToEdit = false;
                    } else if (val.roles[0].id == 5) {
                        // Employee
                        this.ableToEdit = false;
                        this.impersonateUser(val.candidate_id);
                        this.getChecklists(val.candidate_id);
                        $('.sidebar').hide();
                    } else {
                        this.ableToEdit = true;

                        if(val.candidate_id){
                            // Admin with an employee account
                            this.impersonateUser(val.candidate_id);
                            this.getChecklists(val.candidate_id);
                        } else {
                            // Admin not impersonating, get last added candidate with status 3
                            this.getCandidateAndImpersonateUser();
                            this.getLastChecklist();
                        }
                    }
                }

            },
          },
          filterJobs: {
            sync: true,
            handler (val, oldVal) {
                if(oldVal || location.href.indexOf("?timeline") >= 0){
                    this.openSite(val);
                }
            }
          }
        },
        data() {
            return {
                preloader: false,
                formsPreloader: true,
                tableCommentId: 'comments-table',
                finishedGetData: false,
                ableToEdit: true,
                chosenPlace: '',
                newOnboardio: false,
                settings: {},
                inputs: {
                    header: '',
                    body: '',
                    fullsize: '',
                    prefooter: '',
                    footer: '',
                    images: '',
                    currentAnswer: [
                        {id: ''},
                    ],
                    form: [],
                },
                header: {
                    color: '',
                    nav: '',
                    button: '',
                    text: '',
                },
                body: {
                    text1: '',
                    text2: '',
                    text3: '',
                    text4: '',
                    text5: '',
                },
                fullsize: {
                    text1: ''
                },
                prefooter: {
                    text1: '',
                    text2: ''
                },
                footer: {
                    text1: '',
                    text2: '',
                    text3: '',
                    text4: ''
                },
                adverts: {},
                advertsCount: '',
                jobOptions: [
                    {id: '0', value: 'Vyberte pracovní pozici'},

                ],
                filterJobs: 0,
                impersonateAs: '',
                impersonated: {
                    event_date: "2024-08-30 20:10:00",
                },
                impersonatedUrl: '',
                courses: [],
                oldCourses: [],
                candidateOptions: [],
                deadline: '',
                deadlineTo: '',
                deadlineFrom: '',
                checklistsLoaded: false,
                lastChecklistLoaded: false,
                checklistsEmployee: [],
                formsLoaded: false,
                forms: [],

                answer_1: 0,
                answer_2: 0,
                answer_3: 0,
                answerLists: [
                    {id: '0', value: "Ano",},
                    {id: '1', value: "Ne",},
                ],
                testLists: [
                    {id: 'test', value: ''},
                ],
                testField: [
                    {id: '1', value: "",},
                    {id: '2', value: "",},
                    {id: '3', value: "",},
                    {id: '4', value: "",},
                    {id: '5', value: "",},
                    {id: '6', value: "",},
                    {id: '7', value: "",},
                    {id: '8', value: "",},
                    {id: '9', value: "",},
                ],
                testList: [
                    { id: "1", value: "A" },
                    { id: "2", value: "B" },
                    { id: "3", value: "C" },
                ],

            }
        },
        created() {
            this.finishedGetData = true;

            // Check if admin and impersonate set and pass id
            if(location.href.indexOf("impersonate=") != -1){
                let candidateId = parseInt(this.getUrlParameter('impersonate', location.href));
                this.impersonatedUrl = '?impersonate='+candidateId;
                this.impersonateUser(candidateId);
                this.getChecklists(candidateId);
                this.ableToEdit = false;
            }

            this.getSettings();

            window.onscroll = function() {
                var pageHeight = document.documentElement.offsetHeight,
                windowHeight = window.innerHeight,
                scrollPosition = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);


                if (scrollPosition > 253 && window.innerWidth > 991) {
                    $('.right-indent').addClass('fixed');
                } else {
                    $('.right-indent').removeClass('fixed');
                }
            };


        },
        mounted() {
            if ($(".site-container").length > 0){
                $('body').addClass('site-editor');
            }

            $( "#sidebar" ).mouseenter(function() {
                $(".card-header").removeClass("active");
                $("#sidebar").focus();
            });

            // Prevent leaving without saving changes
            let warn = false;
            window.addEventListener('beforeunload', e => {
                if (!warn) return;
                e.preventDefault();
                // Chrome requires returnValue to be set
                e.returnValue = '';
                this.preloader = false;
            });

            $('body').on('click', '.editor, .btn-top-right', function() {
                $('.floating-bar-fixed-bottom').hide();
                if(window.location.href.indexOf("?id") != -1){
                    warn = true;
                }
            });

            $('body').on('click', '.images .btn', function() {
                $('.floating-bar-fixed-bottom').show();
                if(window.location.href.indexOf("?id") != -1){
                    warn = true;
                }
            });

            
        },
        methods: {
            /**
             * Actions
             * */

            getUrlParameter(name, url) {
                if (!url) url = location.href;
                name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
                var regexS = "[\\?&]"+name+"=([^&#]*)";
                var regex = new RegExp( regexS );
                var results = regex.exec( url );
                return results == null ? null : results[1];
            },
            openSite(job) {
                let timelineState = '';

                if (location.href.indexOf("?timeline") >= 0){
                    this.preloader = true;
                    timelineState = '&timeline_state='+parseInt(this.getUrlParameter('timeline', location.href));
                } else if (location.href.indexOf("?id") >= 0){
                    timelineState = '';
                }

                this.axiosGet('admin/app/onboardingsite?job='+job+timelineState).then(response => {
                    if(response.data.length !== 0){
                        window.location.replace('/onboarding/stranka?id='+response.data[0].id+'&job='+job);
                    }
                }).catch(({response}) => {
                }).finally(() => {
                    this.preloader = false;
                });

            },


            /**
             * Get Additional Data
             * */

            getSettings() {
                // Display available jobs and their onboarding sites
                this.axiosGet('get-basic-setting-data').then(response => {
                    this.settings = response.data;
                }).catch(({response}) => {
                }).finally(() => {
                    let root = document.documentElement;
                    let fontColor = this.settings.font_color ? this.settings.font_color : "#a33001";
                    let backgroundColor = this.settings.background_color ? this.settings.background_color : "#fdf1ed";
                    root.style.setProperty('--site-font-color', fontColor);
                    root.style.setProperty('--site-background-color', backgroundColor);
                    this.settings.company_banner = this.settings.company_banner ? this.settings.company_banner : "/images/default-bg-image.png";
                });
            },
            getChecklists(id) {
                // Get checklists for an employee or when impersonating
                let candidateId = id;
                candidateId = candidateId.toString();
                this.axiosGet('admin/app/checklists?filter_with_candidate='+candidateId+'&per_page=500&sortBy=id&orderBy=asc').then(response => {

                const checklistsEmployee = response.data.data.filter( t => t.type == 2);
                    const checklistsEmployeeKeys = checklistsEmployee.map(({
                      status: completed,
                      ...rest
                    }) => ({
                      completed,
                      ...rest
                    }));
                    const checklistsEmployeeValues = checklistsEmployeeKeys.map(obj =>
                        obj.completed === 1 ? { ...obj, completed: false } : { ...obj, completed: true }
                    );

                    this.checklistsEmployee = checklistsEmployeeValues;



                }).catch(({response}) => {
                }).finally(() => {

                    this.preloader = false;
                    this.checklistsLoaded = true;

                });
            },
            getLastChecklist() {
                // Get checklist for admin as a preview
                this.axiosGet('admin/app/last-checklist').then(response => {

                const checklistsEmployee = response.data.data.filter( t => t.type == 2);
                    const checklistsEmployeeKeys = checklistsEmployee.map(({
                      status: completed,
                      ...rest
                    }) => ({
                      completed,
                      ...rest
                    }));
                    const checklistsEmployeeValues = checklistsEmployeeKeys.map(obj =>
                        obj.completed === 1 ? { ...obj, completed: false } : { ...obj, completed: true }
                    );

                    this.checklistsEmployee = checklistsEmployeeValues;



                }).catch(({response}) => {
                }).finally(() => {

                    this.preloader = false;
                    this.checklistsLoaded = true;
                    this.lastChecklistLoaded = true;

                });
            },
            getCourses(){
                // Display courses available by candidate_id/tag/job (for preview impersonate only and real use)
                let currentAtendee = {
                    status: 1, // active courses only
                    timeline_state: JSON.stringify(this.impersonated.timeline_state),
                    event_date: JSON.stringify(this.impersonated.event_date),
                    job: JSON.stringify(this.impersonated.job),
                    id: JSON.stringify(this.impersonated.id),
                    tag: this.impersonated.tag,
                    per_page: 5000
                };

                this.axiosGet('admin/app/my-courses', {
                    params: currentAtendee
                }).then(response => {

                    this.courses = response.data.data;

                }).catch(({response}) => {
                }).finally(() => {
                    this.getCoursesAttachments();
                });

            },
            getCoursesAttachments(){
                this.courses.forEach((e, i) => {
                    this.getCourseAttachment(this.courses[i].id, [i]);
                });
            },
            getCourseAttachment(id, i){
                let courseUrl = "";
                let currentCourse = {
                    course_id: id
                };

                this.axiosGet('/files/course', {
                    params: currentCourse
                }).then(response => {

                    courseUrl = response.data[0].dropzone_file;
                    this.courses[i].attachment = window.location.origin+response.data[0].dropzone_file;

                }).catch(({response}) => {
                }).finally(() => {
                });

            },
            getOldCourses(){
                // Display courses available by candidate_id/tag/job (for preview impersonate only and real use)
                let currentAtendee = {
                    status: 1, // active courses only
                    timeline_state: JSON.stringify(this.impersonated.timeline_state),
                    event_date: JSON.stringify(this.impersonated.event_date),
                    job: JSON.stringify(this.impersonated.job),
                    id: JSON.stringify(this.impersonated.id),
                    tag: this.impersonated.tag,
                    per_page: 5000
                };

                this.axiosGet('admin/app/my-old-courses', {
                    params: currentAtendee
                }).then(response => {

                    this.oldCourses = response.data.data;

                }).catch(({response}) => {
                }).finally(() => {
                    this.getOldCoursesAttachments();
                });

            },
            getOldCoursesAttachments(){
                this.oldCourses.forEach((e, i) => {
                    this.getOldCourseAttachment(this.oldCourses[i].id, [i]);
                });
            },
            getOldCourseAttachment(id, i){
                let courseUrl = "";
                let currentCourse = {
                    course_id: id
                };

                this.axiosGet('/files/course', {
                    params: currentCourse
                }).then(response => {

                    courseUrl = response.data[0].dropzone_file;
                    this.oldCourses[i].attachment = window.location.origin+response.data[0].dropzone_file;

                }).catch(({response}) => {
                }).finally(() => {
                });

            },

            getForms() {
                // Display forms available by candidate_id/tag/job (for preview impersonate only and real use)
                let currentAtendee = {
                    status: 1, // active forms only
                    not_completed: 1, // show only forms that has no answers
                    timeline_state: JSON.stringify(this.impersonated.timeline_state),
                    job: JSON.stringify(this.impersonated.job),
                    id: JSON.stringify(this.impersonated.id),
                    tag: this.impersonated.tag,
                    per_page: 5000
                };

                this.axiosGet('admin/app/my-forms', {
                    params: currentAtendee
                }).then(response => {

                    this.forms = response.data;
                    this.formsLoaded = true;

                }).catch(({response}) => {
                }).finally(() => {

                    this.preloader = false;
                    this.formsPreloader = false;

                });
            },

            getDeadline() {

                if(this.impersonated.event_date){

                    if (this.impersonated.timeline_state == 7) {
                        this.deadline = moment(this.impersonated.eventDate)
                            .subtract(1, "days")
                            .format("YYYY-MM-DD");
                        this.deadlineFrom = moment(this.impersonated.eventDate)
                            .subtract(1, "days")
                            .format("D. M.");
                    } else if (this.impersonated.timeline_state == 8) {
                        this.deadline = moment(this.impersonated.eventDate).format("YYYY-MM-DD");
                        this.deadlineFrom = moment(this.impersonated.eventDate).format("D. M.");
                    } else if (this.impersonated.timeline_state == 9) {
                        this.deadline = moment(this.impersonated.eventDate)
                            .add(1, "days")
                            .format("YYYY-MM-DD");
                        this.deadlineFrom = moment(this.impersonated.eventDate)
                            .add(1, "days")
                            .format("D. M.");
                        this.deadlineTo = moment(this.impersonated.eventDate)
                            .subtract(1, "days")
                            .add(3, "months")
                            .format("D. M.");
                    } 

                }

            },
            getCandidateAndImpersonateUser() {
                let candidateId = 0;
                this.axiosGet('admin/app/last-candidate?status=3').then(response => {
                        candidateId = response.data.id;
                    }).catch(({response}) => {
                    }).finally(() => {
                        this.impersonateUser(candidateId);
                    });
                return candidateId;
            },
            impersonateUser(candidateId) {
                if(candidateId){
                    this.impersonateAs = candidateId;
                }

                // Get impersonated details
                this.axiosGet('admin/app/candidates/'+candidateId).then(response => {

                    this.impersonated = response.data;
                    if(location.href.indexOf("impersonate=") != -1){
                        this.impersonatedUrl = '?impersonate='+candidateId;
                        document.title = this.$t('this_is_how_onboarding_looks_like_for')+' '+this.impersonated.name;
                    }
                    this.getDeadline();
                   
                }).catch(({response}) => {
                }).finally(() => {
                    if(this.impersonated){
                        this.getForms();
                    }
                });
            },

            /**
             * Helpers
             * */
            isDateInFuture(date) {
                return moment(date).isSameOrAfter();
            },
            formatMonthDate(date) {
                let formattedDate = moment(date).locale("cs").format('MMMM');
                return formattedDate;
            },
            formatShortDate(date) {
                let formattedDate = moment(date).format('DD');
                return formattedDate;
            },
            formatDate(date) {
                let addDate = new Date(date);
                let todaysDate = new Date();
                if(addDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
                    return this.$t('today');
                } else {
                    let formattedDate = moment(date).format('DD. MM.');
                    return formattedDate;
                }
            },
            formatTime(date) {
                let addDate = new Date(date);
                let todaysDate = new Date();
                let formattedDate = moment(date).format('HH:mm');
                return formattedDate;
            },
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterSuccessFromGetEditData(response) {

                this.preloader = false;
                this.finishedGetData = true;

            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },

            /**
             * Image upload and set to Chosen Place
             */
            addImageTo(place) {
                this.chosenPlace = place;
                this.$emit('getImageAction', place);
            },
            insertImageToChosenPlace(url){

                if(this.chosenPlace == 'logo'){
                    this.inputs.images.logo = [];
                    this.inputs.images.logo.push(url);
                } else if(this.chosenPlace == 'header'){
                    this.inputs.images.header = [];
                    this.inputs.images.header.push(url);
                } else if (this.chosenPlace == 'body1'){
                    this.inputs.images.body1.push(url);
                } else if (this.chosenPlace == 'body2'){
                    this.inputs.images.body2.push(url);
                } else if (this.chosenPlace == 'body3'){
                    this.inputs.images.body3.push(url);
                } else if (this.chosenPlace == 'body4'){
                    this.inputs.images.body4.push(url);
                } else if (this.chosenPlace == 'fullsize'){
                    this.inputs.images.fullsize.push(url);
                } else if (this.chosenPlace == 'prefooter'){
                    this.inputs.images.prefooter.push(url);
                } else if (this.chosenPlace == 'footer'){
                    this.inputs.images.footer.push(url);
                }

            },
            removeImageFromChosenPlace(url, place){
                if(place == 'logo'){
                    for(var i = 0; i <= this.inputs.images.logo.length - 1; i++){
                        if(this.inputs.images.logo[i] == url){
                            this.inputs.images.logo.splice(i--,1);
                        }
                    }
                } else if(place == 'header'){
                    for(var i = 0; i <= this.inputs.images.header.length - 1; i++){
                        if(this.inputs.images.header[i] == url){
                            this.inputs.images.header.splice(i--,1);
                        }
                    }
                } else if (place == 'body1'){
                    for(var i = 0; i <= this.inputs.images.body1.length - 1; i++){
                        if(this.inputs.images.body1[i] == url){
                            this.inputs.images.body1.splice(i--,1);
                        }
                    }
                } else if (place == 'body2'){
                    for(var i = 0; i <= this.inputs.images.body2.length - 1; i++){
                        if(this.inputs.images.body2[i] == url){
                            this.inputs.images.body2.splice(i--,1);
                        }
                    }
                } else if (place == 'body3'){
                    for(var i = 0; i <= this.inputs.images.body3.length - 1; i++){
                        if(this.inputs.images.body3[i] == url){
                            this.inputs.images.body3.splice(i--,1);
                        }
                    }
                } else if (place == 'body4'){
                    for(var i = 0; i <= this.inputs.images.body4.length - 1; i++){
                        if(this.inputs.images.body4[i] == url){
                            this.inputs.images.body4.splice(i--,1);
                        }
                    }
                } else if(place == 'fullsize'){
                    for(var i = 0; i <= this.inputs.images.fullsize.length - 1; i++){
                        if(this.inputs.images.fullsize[i] == url){
                            this.inputs.images.fullsize.splice(i--,1);
                        }
                    }
                } else if(place == 'prefooter'){
                    for(var i = 0; i <= this.inputs.images.prefooter.length - 1; i++){
                        if(this.inputs.images.prefooter[i] == url){
                            this.inputs.images.prefooter.splice(i--,1);
                        }
                    }
                } else if(place == 'footer'){
                    for(var i = 0; i <= this.inputs.images.footer.length - 1; i++){
                        if(this.inputs.images.footer[i] == url){
                            this.inputs.images.footer.splice(i--,1);
                        }
                    }
                }
            },
            changeColor(){
                let root = document.documentElement;
                root.style.setProperty('--careers-color', this.header.color);
            },
            getCurrentJobName(){
                let currentJobName = this.jobOptions.find(o => o.id === this.filterJobs);
                return currentJobName.value;
            },
            changeImageOrder(arr, from, to){
                return arr.reduce((prev, current, idx, self) => {
                    if (from === to) {
                      prev.push(current);
                    }
                    if (idx === from) {
                      return prev;
                    }
                    if (from < to) {
                      prev.push(current);
                    }
                    if (idx === to) {
                      prev.push(self[from]);
                    }
                    if (from > to) {
                      prev.push(current);
                    }
                    return prev;
                }, []);
            },
        }
    }
</script>
